export default "__VITE_ASSET__S4tEMhCu__"